<template>
    <el-drawer
        title="编辑分享"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="rtl"
        size="700px"
        :before-close="close">
        <div class="panel fx-g1">
            <el-form ref="form" :model="form" label-width="150px" class="edit_form">
                <el-form-item label="分享备课">
                    <el-switch v-model="form.sharing" @change="modifySharing(form)"
                               inactive-color="#ff4949">
                    </el-switch>
                </el-form-item>
                <el-form-item label="分享至教材备课">
                    <el-switch v-model="form.teachingMaterialSharing" @change="modifyTeachingMaterial(form)"
                               inactive-color="#ff4949">
                    </el-switch>
                </el-form-item>
            </el-form>
        </div>
        <span class="fx fx-center">
            <el-button @click="close()">关 闭</el-button>
        </span>
        <el-dialog
            title="提示"
            :visible.sync="showBox1"
            width="30%"
            :before-close="close1"
            >
            <div class="panel form">
                <el-form ref="form1" :model="form1" label-width="150px" class="edit_form">
                    <el-form-item label="教材">
                        <el-select v-model="form1.teachingMaterialId" placeholder="请选择教材" @change="getContent()">
                            <el-option
                                v-for="item in options"
                                :key="item.id"
                                :label="item.title"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="请选择教材课程">
                        <el-select v-model="form1.teachingMaterialContentId" placeholder="请选择教材课程">
                            <el-option
                                v-for="item in options1"
                                :key="item.id"
                                :label="item.title"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer fx fx-center">
                <el-button type="primary" @click="sub()">确 定</el-button>
                <el-button @click="close1()">关 闭</el-button>
            </span>
        </el-dialog>
    </el-drawer>
</template>

<style scoped>
    .task {
        border-radius: 6px;
        border: 1px solid var(--border);
        min-height: 40px;
        position: relative;
        padding: 20px;
    }

    .task_close {
        position: absolute;
        right: 10px;
        top: 10px;
        color: var(--lighter);
        cursor: pointer;
        font-size: 20px;
    }

    .task_close:hover {
        color: var(--primary);
    }

    .task_form {
        width: 80%;
    }

</style>


<script>

    import {mapMutations} from "vuex";
    export default {
        props: [
            "item",
        ],
        data() {
            return {
                showBox1: false,
                show:true,
                form: {...this.item},
                form1:{teachingMaterialId:'',teachingMaterialContentId:''},
                options:[],
                options1:[],
            }

        },
        computed: {
        },
        methods: {
            ...mapMutations(),
            close() {
                this.$emit("close");
            },
            modifySharing(item) {
                this.$ajaxGet("/lesson/toggleSharing/" + item.id + "-" + item.sharing);
                this.$showSuccess("操作成功");
            },
            modifyTeachingMaterial(lesson){
                this.form1.teachingMaterialId = '';
                this.form1.teachingMaterialContentId = '';
                if(!lesson.teachingMaterialSharing){
                    this.$confirm('确定取消分享吗?', '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning'
                    }).then(() => {
                        this.form1.teachingMaterialId = 0;
                        this.form1.teachingMaterialContentId = 0;
                        this.sub();
                    }).catch(() => {
                    });
                    return;
                }
                console.log(1)
                this.showBox1 = true;
            },
            sub(){
                this.$ajaxGet("/lesson/doTeachingMaterial/"+this.item.id + "-" + this.form1.teachingMaterialContentId, (data) => {
                    this.$showSuccess("操作成功");
                    this.showBox1 = false;
                })
            },
            close1(){
                this.showBox1 = false;
            },
            loadTeachingMaterial(){
                this.$ajaxGet("/teachingMaterial/listOption", (data) => {
                    this.options = data.result;
                })
            },
            getContent(){
                this.$ajaxGet("/teachingMaterialContent/listByTeachingMaterialId/"+this.form1.teachingMaterialId, (data) => {
                    this.options1 = data.result;
                })
            },
        },
        mounted() {
        },
        created() {
            this.loadTeachingMaterial();
        },
        beforeDestroy() {
        }

    }
</script>
